import Image from 'next/image'
import { useNextSanityImage } from 'next-sanity-image'

import { Box } from '@mui/material'

import { sanityConfig } from '@/lib/config.shared'

import type { FC } from 'react'
import type { PortableTextTypeComponentProps } from '@portabletext/react'
import type { ExtendedImage } from '@/gen/sanity/schema'

interface SanityBlockContentImageProps {
  portableTextImageProps: PortableTextTypeComponentProps<ExtendedImage>
}

export const SanityBlockContentImage: FC<SanityBlockContentImageProps> = ({ portableTextImageProps }) => {
  const extendedImage = portableTextImageProps.value
  const imageProps = useNextSanityImage(sanityConfig, extendedImage)

  const imageWidth =
    extendedImage.resize === 'widthResize'
      ? extendedImage.width + '%'
      : extendedImage.resize === 'default'
        ? '100%'
        : 'auto'

  if (!imageProps && extendedImage) {
    return <></>
  }

  return (
    <Box
      position="relative"
      sx={{
        height: 'auto',
        textAlign: extendedImage?.imagePlacement,
        overflow: 'hidden',
        mt: 2,
      }}
    >
      <Image
        {...imageProps}
        alt={portableTextImageProps?.value.alt || ' '}
        style={{
          width: imageWidth,
          height: 'auto',
          maxWidth: imageWidth,
          maxHeight: '100%',
        }}
        sizes="(max-width: 800px) 100vw, 800px"
      />
    </Box>
  )
}
